import React from 'react';
import ReactDOM from 'react-dom';
import Login from './login';
import Search from './Search';
import ItemList from './ItemList/ItemList';
import ItemDetails from './ItemDetails/ItemDetails';
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Switch>
        <Route path='/item_details' component={ItemDetails} />
        <Route path='/item_list' component={ItemList} />
        <Route path='/search' component={Search} />
        <Route path='/' component={Login} />
      </Switch>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
serviceWorker.register();
